import React from "react"
import PropTypes from "prop-types"
import { galerieImage } from "./galerie-images.module.scss"
import NonStretchedImage from "../../Image/non-stretched-image"

//-----------------------Parent component---------------------------//

const FinalGalerieComponent = ({ data, zoneLibre, children }) => {
  const altAttributes = data.field_images.map((element) => {
    return element.alt
  })
  let finalGalerie = data.relationships.field_images.map((element, index) => {
    return { ...element, alt: altAttributes[index] }
  })
  if (zoneLibre) {
    finalGalerie = finalGalerie.slice(0, 6)
  }
  const images = finalGalerie.map((element, key) => {
    return (
      <NonStretchedImage
        ariaHidden={true}
        className={galerieImage}
        key={key}
        alt={element.alt}
        {...element.localFile}
      />
    )
  })
  return children({ images })
}

//-----------------------Parent component---------------------------//

FinalGalerieComponent.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  children: PropTypes.func,
}

export default FinalGalerieComponent
